// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__3nKSK","section":"Contact_section__108j4","box":"Contact_box__iR58W"};